import type { FC } from "react";

import { ExportTablesSelectionModal } from "src/app/features/ConfigurationTransfer/components/buttons/ExportTablesSelectionModal";
import { ZipImportButton } from "src/app/features/ConfigurationTransfer/components/buttons/ZipImportButton";
import { ActionBar } from "../../../../../components/ActionBar/ActionBar";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";

export const ConfigurationTransferEditForm: FC = () => {
    const dataGroup = getAssignedDataGroup();

    return (
        <ActionBar className="left">
            <ExportTablesSelectionModal buttonTextKey="button.exportConfig" />
            <ZipImportButton
                name="configuration_transfer_import_button"
                isImport
                translationKey={"button.importConfig"}
                urlString={`${ResourceName.DATA_GROUPS}/${dataGroup.id}/config-import`}
            />
            <ZipImportButton
                name="configuration_transfer_update_button"
                isImport={false}
                translationKey={"button.updateConfig"}
                urlString={`${ResourceName.DATA_GROUPS}/${dataGroup.id}/config-update`}
            />
        </ActionBar>
    );
};
